<nz-row [nzGutter]="10">
  <nz-col [nzSpan]="24"  style="margin-bottom: 10px;">

    <div class="dash-wrapper">
      <ng-container *ngFor="let item of dashItemsValues" >    
      <nz-card class="dash-card" *ngIf="item.enabled"
       (click)="showData(item.name)" [ngClass]="{'dash-card-6':enbledItems == 6,'dash-card-5':enbledItems == 5, 'dash-card-active':item.selected === true}"> 
        <div nz-row>
          <div nz-col nzSpan="16" >
            <nz-statistic class="dash-stat"
            [nzValue]="item.model"
            [nzTitle]="item.name"
            [nzValueStyle]="{ color: '#6C757D' }">
          </nz-statistic>
          </div>
          <div nz-col nzSpan="8" nzOffset="0" class="dash-item-icon">
            <span nz-icon [nzType]="item.icon" nzTheme="outline"></span>
          </div>
        </div>  
      </nz-card>
    </ng-container>
    </div>
      


</nz-col> 
  </nz-row>